import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Pane,
  PaneFooter,
  Paneset,
  Row,
  TextField,
} from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import stripesFinalForm from '@folio/stripes/final-form';
import { required } from '../../helpers/Validations';

function CubeConnectionForm({ handleSubmit, pristine, submitting, canManage = false, form }) {
  const intl = useIntl();

  const renderPaneFooter = () => (
    <PaneFooter
      renderEnd={
        <Button
          buttonStyle="primary"
          disabled={pristine || submitting || !canManage}
          id="cube-connection-settings-save-btn"
          marginBottom0
          type="submit"
        >
          <FormattedMessage id="stripes-core.button.save" />
        </Button>
      }
      renderStart={
        <Button
          buttonStyle="default"
          disabled={pristine || submitting || !canManage}
          id="cube-connection-settings-cancel-btn"
          marginBottom0
          onClick={() => form.reset()}
        >
          <FormattedMessage id="stripes-components.cancel" />
        </Button>
      }
    />
  );

  return (
    <form
      id="form-cube-connection-settings"
      onSubmit={handleSubmit}
      style={{ width: 'inherit' }}
    >
      <Paneset>
        <Pane
          fluidContentWidth
          footer={renderPaneFooter()}
          id="cube-connection-settings-pane"
          paneTitle={
            <FormattedMessage id="ui-reports.settings.cubeConnection.paneTitle" />
          }
        >
          <Row>
            <Col xs={8}>
              <Field
                id="settings-cube-url-field"
                name="cubeUrl"
                component={TextField}
                label={
                  <FormattedMessage id="ui-reports.settings.cubeConnection.url.label" />
                }
                placeholder={intl.formatMessage({
                  id: 'ui-reports.settings.cubeConnection.url.placeholder',
                })}
                required
                validate={required}
                fullWidth
              />
            </Col>
          </Row>
          <Row>
            <Col xs={8}>
              <Field
                id="settings-cube-secret-field"
                name="cubeSecret"
                component={TextField}
                type="password"
                label={
                  <FormattedMessage id="ui-reports.settings.cubeConnection.secret.label" />
                }
                placeholder={intl.formatMessage({
                  id: 'ui-reports.settings.cubeConnection.secret.placeholder',
                })}
                fullWidth
              />
            </Col>
          </Row>
        </Pane>
      </Paneset>
    </form>
  );
}

CubeConnectionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  form: PropTypes.object.isRequired,
};

export default stripesFinalForm({
  navigationCheck: true,
  subscription: { values: true },
  validateOnBlur: true,
})(CubeConnectionForm);
